import { isEmptyObject } from "../../../utils/tests";
import { CompetitionBoardQuery } from '../types';

/**
 * typeguard for CompetitionBoardQuery
 * @param CompetitionBoardQuery object passed to transformer
 */
export const isValidCompetitionBoard = (obj: CompetitionBoardQuery): boolean => Boolean(obj?.data?.getCompetitionBoard && !isEmptyObject(obj.data.getCompetitionBoard));
